var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, observable } from 'mobx';
import { deleteProjects, getBatchDetail, getBatchDetails, getProjectsProposals, matchProjects, rematchProject } from '@gtintel/platform-api';
let AdminBatchRequestDetailStore = (_class = class AdminBatchRequestDetailStore {
  constructor(rootStore) {
    this.rootStore = void 0;
    _initializerDefineProperty(this, "batchRequestDetail", _descriptor, this);
    _initializerDefineProperty(this, "matchPartners", _descriptor2, this);
    _initializerDefineProperty(this, "isLoading", _descriptor3, this);
    _initializerDefineProperty(this, "isLoadingMatchPartners", _descriptor4, this);
    _initializerDefineProperty(this, "isDeleteProjectsSuccess", _descriptor5, this);
    _initializerDefineProperty(this, "isMatchProjectsSuccess", _descriptor6, this);
    _initializerDefineProperty(this, "isRematchProjectsSuccess", _descriptor7, this);
    this.rootStore = rootStore;
  }
  async fetchBatchRequestDetail(id) {
    this.isLoading = true;
    const response = await getBatchDetail(id);
    this.batchRequestDetail = response;
    this.isLoading = false;
  }
  async fetchBatchRequestDetailWithFilter(params) {
    this.isLoading = true;
    const formatParams = {
      ...params,
      prosearch: params.searchContent
    };
    const response = await getBatchDetails(formatParams);
    this.batchRequestDetail = response;
    this.isLoading = false;
  }
  async fetchMatchPartners(projectId) {
    this.isLoadingMatchPartners = true;
    const response = await getProjectsProposals(projectId);
    this.matchPartners = response.result;
    this.isLoadingMatchPartners = false;
  }
  async deleteProjects(projectIds) {
    try {
      const formatData = Array.isArray(projectIds) ? projectIds.map(projectId => ({
        project_id: projectId
      })) : [];
      await deleteProjects(formatData);
      this.isDeleteProjectsSuccess = true;
    } catch (error) {
      this.isDeleteProjectsSuccess = false;
    }
  }
  async matchPartnerForProjects(matchProjectsData) {
    try {
      await matchProjects(matchProjectsData);
      this.isMatchProjectsSuccess = true;
    } catch (error) {
      this.isMatchProjectsSuccess = false;
    }
  }
  async rematchPartnerForProjects(rematchProjectsData) {
    try {
      await rematchProject(rematchProjectsData);
      this.isRematchProjectsSuccess = true;
    } catch (error) {
      this.isRematchProjectsSuccess = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "batchRequestDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "matchPartners", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isLoadingMatchPartners", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isDeleteProjectsSuccess", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isMatchProjectsSuccess", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isRematchProjectsSuccess", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetchBatchRequestDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchBatchRequestDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchBatchRequestDetailWithFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchBatchRequestDetailWithFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchMatchPartners", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchMatchPartners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteProjects", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteProjects"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "matchPartnerForProjects", [action], Object.getOwnPropertyDescriptor(_class.prototype, "matchPartnerForProjects"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rematchPartnerForProjects", [action], Object.getOwnPropertyDescriptor(_class.prototype, "rematchPartnerForProjects"), _class.prototype), _class);
export { AdminBatchRequestDetailStore as default };